import { Aux } from './AuxillaryServices';
import { $, jQuery } from '../../vendor/jquery';
import _ from 'underscore';

function FacilitatorGetRequest(endpoint) {
    return $.ajax({
        url: 'https://localhost:8082/Facilitator/' + endpoint,
        dataType: 'json',
    });
}

function Facilitator() {
    var t = this;

    this.dcp = jQuery.Deferred();
    this.enabled = undefined;
    this.initialized = false;

    this.getNetworkInfo = function () {
        var dfd = jQuery.Deferred();

        var resolveFx = function () {
            FacilitatorGetRequest('NetworkInfo').then(
                function (data) {
                    dfd.resolve(data);
                },
                function () {
                    dfd.reject();
                }
            );
        };

        if (typeof t.enabled == 'undefined') {
            this.dcp.then(function () {
                resolveFx();
            });
        } else {
            resolveFx();
        }

        return dfd.promise();
    };

    this.getSystemProfile = function () {
        var dfd = jQuery.Deferred();

        var resolveFx = function () {
            FacilitatorGetRequest('SystemProfile').then(
                function (data) {
                    dfd.resolve(data);
                },
                function () {
                    dfd.reject();
                }
            );
        };

        if (typeof t.enabled == 'undefined') {
            this.dcp.then(function () {
                resolveFx();
            });
        } else {
            resolveFx();
        }

        return dfd.promise();
    };

    this.serviceAvailable = function () {
        return t.enabled === true;
    };

    this.onDiscoveryComplete = function (enabled) {
        t.enabled = enabled;

        if (!this.initialized) {
            this.initialized = true;
        }

        t.dcp.resolve();
    };
}

function FacilitatorBase() {}

FacilitatorBase.m_Loaded = false;
FacilitatorBase.Mechanism = null;

FacilitatorBase.onServiceDiscovered = function (event, param) {
    switch (event) {
        case 'Initialize': {
            if (!FacilitatorBase.Mechanism) {
                FacilitatorBase.Mechanism = new Facilitator();

                Aux.RegisterService('Facilitator', FacilitatorBase.Mechanism);
            }

            break;
        }
        case 'ServicesDiscovered': {
            if (_.contains(param, 'REACH.Facilitator')) {
                //enable facilitator
                FacilitatorBase.Mechanism.onDiscoveryComplete(true);
            }

            break;
        }
        case 'DiscoveryFailed': {
            //facilitator is not available!
            FacilitatorBase.Mechanism.onDiscoveryComplete(false);

            break;
        }
    }
};

/**
 * @todo document this
 */
function initializeFacilitator() {
    Aux.AddListener(FacilitatorBase.onServiceDiscovered);
}

export { initializeFacilitator };
